import { Component, Input } from '@angular/core';
import { EventBasic } from '../../../data-services/models/events/event-basic.model';
import { EventsSummaryComponent } from "../../summary/feature/summary.component";
import { DividerModule } from 'primeng/divider';
import { Router, RouterModule } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-events-summary-list',
  imports: [EventsSummaryComponent, DividerModule, RouterModule],
  templateUrl: '../ui/summary-list.component.html',
  styleUrl: '../ui/summary-list.component.css',
})
export class SummaryListComponent {
  @Input({ required: true }) eventList!: EventBasic[];

  constructor(private readonly _router:Router){}

  navigate(selectedEvent: EventBasic) {
    this._router.navigate([`/events/${selectedEvent.eventLink}/book`])
  }
}
